import React from "react";
import Logo from "../images/openparking_logo.png";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrapper = styled.header`
  position: relative;
  width: 100%;
  height: 120px;
  left: 0px;
  top: 0px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);

`;

const Image = styled.img`
  width: 146.03px;
  height: 40px;
`;
Image.defaultProps = {
  src: Logo,
};

export default function Header() {
  return (
    <Wrapper>
      <Link to="/">
        <Image />
      </Link>
    </Wrapper>
  );
}
